import React from "react";
import Tooltip from "@mui/material/Tooltip";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

export function ChatModeToggle({
  value,
  onChange,
  iconSize = 18,
  buttonPaddingX = 1.25,
}) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      size="small"
      aria-label="chat mode"
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        border: "1px solid rgba(24, 116, 210, 0.16)",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        overflow: "hidden",
        "& .MuiToggleButton-root": {
          border: "none",
          color: "#666666",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            backgroundColor: "rgba(24, 116, 210, 0.06)",
            transform: "translateY(-1px)",
          },
        },
        "& .MuiToggleButton-root.Mui-selected": {
          backgroundColor: "rgba(24, 116, 210, 0.08)",
          color: "rgba(24, 116, 210, 1)",
          border: "1px solid rgba(24, 116, 210, 0.2)",
          "&:hover": {
            backgroundColor: "rgba(24, 116, 210, 0.12)",
          },
        },
      }}
    >
      <ToggleButton
        value="normal"
        aria-label="normal chat"
        sx={{ px: buttonPaddingX }}
        disableRipple
      >
        <Tooltip title="Normal chat">
          <ChatBubbleOutlineIcon sx={{ fontSize: iconSize }} />
        </Tooltip>
      </ToggleButton>
      <ToggleButton
        value="deep"
        aria-label="deep research"
        sx={{ px: buttonPaddingX }}
        disableRipple
      >
        <Tooltip title="Deep research chat">
          <ScienceOutlinedIcon sx={{ fontSize: iconSize }} />
        </Tooltip>
      </ToggleButton>
      <ToggleButton
        value="planner"
        aria-label="planner"
        sx={{ px: buttonPaddingX }}
        disableRipple
      >
        <Tooltip title="Planner chat">
          <AccountTreeIcon sx={{ fontSize: iconSize }} />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
